import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Modal,
  TextField,
  Tooltip,
  makeStyles,
} from "@material-ui/core";
import React, { useEffect, useMemo, useState } from "react";
import {
  addApiRole,
  deleteRole,
  updateApiRole,
  updatePermissionUser,
  updateSystemConfig,
} from "../../Utils/actions";
import cogoToast from "cogo-toast";
import { useDispatch, useSelector } from "react-redux";
import SaveIcon from "@mui/icons-material/Save";
import { Form } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import {
  MRT_EditActionButtons,
  MaterialReactTable,
} from "material-react-table";
import { useTranslation } from "react-i18next";
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
} from "@mui/icons-material";
import { Settings } from "@material-ui/icons";

import { loadingOn } from "../../Utils/utils";
import ForwardIcon from "@mui/icons-material/Forward";
import SettingsIcon from "@mui/icons-material/Settings";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import LastPageIcon from "@mui/icons-material/LastPage";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import FormControl from "@mui/material/FormControl";
import { Select, MenuItem } from "@mui/material";
import { successMsg } from "../../Utils/errorMsg/ErrorMsg";
import { buttonStyle } from "../../Style/ManualStyle";
import CloseIcon from "@mui/icons-material/Close";

const AddRoles = ({
  setTabs,
  onPermission,
  roleTablePagination,
  pageIndexAddRole,
  setPageIndexAddRole,
  pageSizeAddRole,
  setPageSizeAddRole,
  onPermissionRole,
}) => {
  const [form, setForm] = useState({ roleName: "", description: "" });
  const [error, setError] = useState({ roleName: "", description: "" });
  const [deleteRow, setDeleteRow] = useState({});
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [editColumn, setEditColumn] = useState(true);
  const { rolesData, roleTableCount, allRole } = useSelector(
    (state) => state.data
  );

  sessionStorage.setItem("addRolePageSize", pageSizeAddRole);
  const handleChange = (e) => {
    setError({ ...error, [e.target.name]: "" });
    setForm({ ...form, [e.target.name]: e.target.value });
  };
  // const { rolesData } = useSelector((state) => state.data)
  // const rolesData = [
  //     {
  //         roleName: 'RigAdmin',
  //         description: 'RigAdmin'
  //     },
  //     {
  //         roleName: 'SigmaAdmin',
  //         description: 'SigmaAdmin'
  //     },
  //     {
  //         roleName: 'StreamParallel',
  //         description: 'Stream'
  //     }
  // ]

  const handlePageChange = (newPageIndex) => {
    setPageIndexAddRole(newPageIndex);
  };
  const handleStartChange = () => {
    setPageIndexAddRole(0);
  };

  const handleEndChange = () => {
    const totalPages = Math.ceil(roleTableCount / pageSizeAddRole);
    setPageIndexAddRole(totalPages - 1);
  };

  const handlePageSizeChange = (newPageSize) => {
    setPageSizeAddRole(newPageSize);
    setPageIndexAddRole(0);
  };

  const roleColumns = useMemo(
    () => [
      {
        accessorKey: "roleName",
        header: "Role Name",
        enableResizing: true,
        size: 20,
        // enableEditing: (row) => row.original && row.original.isNewRow ? true : false,
      },
      {
        accessorKey: "description",
        header: "Description",
        enableResizing: true,
        size: 20,
      },
    ],
    [t]
  );

  const handleSubmit = (e, table) => {
    e.preventDefault();
    if (!form.roleName) {
      setError({ ...error, roleName: "Role is required" });
      return;
    }

    try {
      dispatch(addApiRole(form, location, pageSizeAddRole, pageIndexAddRole));
      setForm({ description: "", roleName: "" });
      if (location.pathname === "/validForm") {
        onPermission(true);
      }
      table.setCreatingRow(null);
    } catch (err) {
      cogoToast.error("Role is not saved!");
    }
  };

  const useStyles = makeStyles((theme) => ({
    input: {
      "&::placeholder": {
        color: "#000000", // Customize the color here
      },
      color: "#000000",
    },
  }));

  const textPlaceHolder = useStyles();

  const handleDeleteCancel = () => {
    setDeleteConfirm(false);
    setDeleteConfirmOpen(false);
  };

  const handleDeleteConfirm = () => {
    // Handle delete logic here
    setDeleteConfirm(true);
    setDeleteConfirmOpen(false);
  };

  const openDeleteConfirmModal = (row) => {
    setDeleteConfirmOpen(true);
    setDeleteRow(row.original);
    // return (
    //     <>

    //     </>)
  };

  const handleInternalChange = (name, value) => {
    setForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (deleteConfirm) {
      setDeleteConfirm(false);
      dispatch(loadingOn());
      dispatch(deleteRole(deleteRow, pageSizeAddRole, pageIndexAddRole));
    }
  }, [deleteConfirmOpen]);

  const onhandleSave = ({ row, table }) => {
    dispatch(
      addApiRole(row._valuesCache, location, pageSizeAddRole, pageIndexAddRole)
    );
    setForm({ description: "", roleName: "" });
    if (location.pathname === "/validForm") {
      setTabs({ name: "user", val: 1 });
    }
    table.setCreatingRow(null);
  };
  const onEditRole = ({ row, table }) => {
    dispatch(
      updateApiRole(
        row._valuesCache,
        location,
        pageSizeAddRole,
        pageIndexAddRole
      )
    );
    if (location.pathname === "/validForm") {
      setTabs({ name: "user", val: 1 });
    }
    table.setEditingRow(null);
  };

  const onEditSaveRole = (table) => {
    dispatch(updateApiRole(form, location, pageSizeAddRole, pageIndexAddRole));
    if (location.pathname === "/validForm") {
      setTabs({ name: "user", val: 1 });
    }
    table.setEditingRow(null);
  };

  const onEditHandle = ({ row, table }) => {
    dispatch(updatePermissionUser(row._valuesCache));
    table.setEditingRow(null);
  };

  const createContentBox = ({ table, row, internalEditComponents }) => {
    return (
      <>
        {/* <DialogTitle style={{backgroundColor:"#3b6a89", color:"white"}} variant="h3">Create Role</DialogTitle>
                <DialogContent
                    sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}
                >
                    {internalEditComponents} 
                </DialogContent>
                <DialogActions>
                    <MRT_EditActionButtons variant="text" table={table} row={row} />
                </DialogActions> */}
        <DialogTitle
          style={{ backgroundColor: "#161616", color: "#c7c7c7" }}
          variant="h3"
        >
          Create Role
        </DialogTitle>
        <Box
          component="form"
          className="addUserBox"
          // onSubmit={(e) => handleSubmit(e)}
          noValidate
          autoComplete="off"
        >
          <DialogContent style={{ display: "flex" }}>
            <TextField
              label="Role name"
              variant="outlined"
              name="roleName"
              value={form.roleName}
              style={{ margin: "5px" }}
              onChange={handleChange}
            />
            <TextField
              label="Description"
              variant="outlined"
              name="description"
              value={form.description}
              type="text"
              style={{ margin: "5px" }}
              onChange={handleChange}
            />
          </DialogContent>

          <DialogActions>
            <Button
              // type="button"
              // style={{
              //   color: "#286685",
              // }}
              startIcon={<CloseIcon />}
              onClick={() => table.setCreatingRow(null)}
              style={buttonStyle}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              onClick={(e) => handleSubmit(e, table)}
              startIcon={<SaveIcon />}
              style={buttonStyle}
            >
              Save
            </Button>
          </DialogActions>
        </Box>
      </>
    );
  };
  const editContentBox = ({ internalEditComponents, row, table }) => {
    const change = (row) => {};

    return (
      <>
        {/* <DialogTitle style={{ backgroundColor:"#3b6a89", color:"white"}} variant="h3">Edit Role</DialogTitle>
                <DialogContent
                    sx={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}
                >
                    {internalEditComponents} 
                </DialogContent>
                <DialogActions>
                    <MRT_EditActionButtons variant="text" table={table} row={row} />
                </DialogActions> */}
        <DialogTitle
          style={{ backgroundColor: "#3b6a89", color: "white" }}
          variant="h3"
        >
          Edit Role
        </DialogTitle>
        <Box
          component="form"
          className="addUserBox"
          // onSubmit={(e) => handleSubmit(e)}
          noValidate
          autoComplete="off"
        >
          <DialogContent style={{ display: "flex" }}>
            <TextField
              label="Role name"
              variant="outlined"
              name="roleName"
              value={row._valuesCache.roleName}
              disabled={true}
              style={{ margin: "5px" }}
              onChange={() => {
                change(row);
              }}
            />
            <TextField
              label="Description"
              variant="outlined"
              name="description"
              value={row._valuesCache.description}
              type="text"
              style={{ margin: "5px" }}
              onChange={() => {
                change(row);
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button
              type="button"
              style={{
                color: "#286685",
              }}
              onClick={() => table.setEditingRow(null)}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              onClick={() => onEditSaveRole(table)}
              startIcon={<SaveIcon />}
              style={{
                backgroundColor: "#286685",
                color: "#fff",
              }}
            >
              Save
            </Button>
          </DialogActions>
        </Box>
      </>
    );
  };
  const onClickListener = ({ row, table }) => {
    table.setEditingRow(null);
  };

  const cmpntGroup =
    sessionStorage?.getItem("cmpntGroup") !== null
      ? JSON.parse(sessionStorage?.getItem("cmpntGroup"))
      : "{}";

  return (
    <>
      <div
        style={{
          display: "block",
          position: "relative",
          width: "100%",
          // padding: "0px 15px",
        }}
      >
        <div className="col-md-12 m-0 p-0 overflow-auto border-0">
          <MaterialReactTable
            muiTableHeadCellProps={{
              sx: {
                backgroundColor: "#2e2e2e", // dark head
                color: "#ccc",
              },
            }}
            muiTableHeadProps={{
              sx: {
                overflow: "auto",
                backgroundColor: "#2e2e2e",
                "&::-webkit-scrollbar": {
                  width: "12px",
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#444", // darker thumb
                  borderRadius: "6px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  backgroundColor: "#555",
                },
                "&::-webkit-scrollbar-track": {
                  backgroundColor: "#2e2e2e",
                },
              },
            }}
            muiTableHeadCellContentProps={{
              sx: {
                color: "#ccc !important", // text color
                "& svg": {
                  color: "#ccc !important", // sort icon color
                },
              },
            }}
            muiTableBodyProps={{
              sx: {
                overflow: "auto",
                scrollbarWidth: "thin",
                backgroundColor: "#181818", // dark body
                "&::-webkit-scrollbar": {
                  width: "10px",
                  backgroundColor: "#181818",
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#444",
                  borderRadius: "6px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  backgroundColor: "#555",
                },
                "&::-webkit-scrollbar-track": {
                  backgroundColor: "#23272f",
                },
                // "& tr:nth-of-type(odd)": {
                //   backgroundColor: "#23272f",
                // },
                // "& tr:nth-of-type(even)": {
                //   backgroundColor: "#181818",
                // },
                "& td": {
                  padding: "0.5rem",
                  borderBottom: "1px solid #333",
                  color: "#c7c7c7",
                },
              },
            }}
            muiTableContainerProps={{
              sx: {
                maxHeight: "59vh",
                overflowY: "auto",
                overflowX: "auto",
                backgroundColor: "#181818", // dark container
              },
            }}
            muiTablePaperProps={{
              sx: {
                boxShadow: "none",
                height: "auto",
                width: "100%",
                position: "static",
                display: "block",
                overflowY: "auto",
                overflowX: "auto",
                backgroundColor: "#23272f", // dark table background
                scrollbarWidth: "thin",
                "&::-webkit-scrollbar": {
                  width: "12px",
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#444",
                  borderRadius: "6px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  backgroundColor: "#555",
                },
                "&::-webkit-scrollbar-track": {
                  backgroundColor: "#23272f",
                },
              },
            }}
            muiTableBodyRowProps={({ row, index }) => ({
              sx: {
                backgroundColor: row.getIsSelected()
                  ? "#1c1c1c"
                  : // : index % 2 === 0
                    // ? "#cfd5e959"
                    "#121212",
              },
            })}
            enableStickyFooter={true}
            enableStickyHeader={true}
            columns={roleColumns}
            data={rolesData}
            enableRowActions
            createDisplayMode="modal"
            positionActionsColumn="last"
            onCreatingRowSave={onhandleSave}
            editDisplayMode={"modal"}
            enableEditing={true}
            onEditingRowCancel={onClickListener}
            onEditingRowSave={onEditRole}
            enableDensityToggle={false}
            getRowId={(row) => row.id}
            enableFullScreenToggle={false}
            enableFilters={false}
            enableHiding={false}
            muiPaginationProps={({ table }) => ({
              showRowsPerPage: true,
            })}
            renderCreateRowDialogContent={createContentBox}
            rowCount={roleTableCount}
            state={roleTablePagination}
            renderTopToolbar={({ table, row }) => (
              <div
                className="d-flex w-100 justify-content-end"
                style={{
                  background: "#181818",
                  alignItems: "center",
                  padding: "0.5rem 1rem",
                  flexWrap: "wrap",
                  gap: "1rem",
                }}
              >
                {(location.pathname === "/validForm" ||
                  cmpntGroup["user"]?.Add) && (
                  <Tooltip title="Create Role">
                    <Button
                      startIcon={<AddIcon />}
                      style={{
                        marginRight: "10px",
                        width: "100px",
                        padding: "5px 10px",
                        background: "linear-gradient(135deg, #4f4f4f, #1e1e1e)",
                        border: "1px solid #3a3a3a",
                        color: "#ffffff",
                        fontSize: "5px",
                        borderRadius: "6px",
                        cursor: "pointer",
                        boxShadow: "0 0 8px rgba(0, 0, 0, 0.6)",
                        transition: "background 0.3s ease, transform 0.2s ease",
                      }}
                      onClick={() => {
                        table.setCreatingRow(true);
                        //simplest way to open the create row modal with no default values
                        setForm({ roleName: "", description: "" });
                      }}
                    >
                      Create
                    </Button>
                  </Tooltip>
                )}
              </div>
            )}
            enablePagination={false}
            renderBottomToolbarCustomActions={({ table }) => (
              <>
                <div style={{ marginLeft: "auto", color: "c7c7c7" }}>
                  <span>Rows per Page </span>&nbsp;
                  <FormControl variant="standard" size="small">
                    <Select
                      value={pageSizeAddRole}
                      onChange={(e) =>
                        handlePageSizeChange(Number(e.target.value))
                      }
                      sx={{
                        color: "#c7c7c7",
                        ".MuiSelect-icon": { color: "#c7c7c7" },
                        ".MuiOutlinedInput-notchedOutline": {
                          borderColor: "#444",
                        },
                      }}
                    >
                      <MenuItem value={5}>5</MenuItem>
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={20}>20</MenuItem>
                      <MenuItem value={50}>50</MenuItem>
                      <MenuItem value={100}>100</MenuItem>
                    </Select>
                  </FormControl>
                  &nbsp;
                  <span>
                    {pageIndexAddRole * pageSizeAddRole + 1}-
                    {Math.min(
                      pageIndexAddRole * pageSizeAddRole + pageSizeAddRole,
                      roleTableCount
                    )}{" "}
                    of &nbsp;
                    {roleTableCount}&nbsp;
                  </span>
                  <FirstPageIcon
                    onClick={() => {
                      if (pageIndexAddRole !== 0) {
                        handleStartChange();
                      }
                    }}
                    style={{
                      cursor:
                        pageIndexAddRole === 0 ? "not-allowed" : "pointer",
                      color:
                        pageIndexAddRole === 0
                          ? "rgba(255,255,255,0.26)"
                          : "#c7c7c7",
                    }}
                  />
                  <NavigateBeforeIcon
                    onClick={() => {
                      if (pageIndexAddRole !== 0) {
                        handlePageChange(pageIndexAddRole - 1);
                      }
                    }}
                    style={{
                      cursor:
                        pageIndexAddRole === 0 ? "not-allowed" : "pointer",
                      color:
                        pageIndexAddRole === 0
                          ? "rgba(255,255,255,0.26)"
                          : "#c7c7c7",
                    }}
                  />
                  <NavigateNextIcon
                    onClick={() => {
                      if (
                        (pageIndexAddRole + 1) * pageSizeAddRole <
                        roleTableCount
                      ) {
                        handlePageChange(pageIndexAddRole + 1);
                      }
                    }}
                    style={{
                      cursor:
                        (pageIndexAddRole + 1) * pageSizeAddRole >=
                        roleTableCount
                          ? "not-allowed"
                          : "pointer",
                      color:
                        (pageIndexAddRole + 1) * pageSizeAddRole >=
                        roleTableCount
                          ? "rgba(255,255,255,0.26)"
                          : "#c7c7c7",
                    }}
                  />
                  <LastPageIcon
                    onClick={() => {
                      if (
                        (pageIndexAddRole + 1) * pageSizeAddRole <
                        roleTableCount
                      ) {
                        handleEndChange();
                      }
                    }}
                    style={{
                      cursor:
                        (pageIndexAddRole + 1) * pageSizeAddRole >=
                        roleTableCount
                          ? "not-allowed"
                          : "pointer",
                      color:
                        (pageIndexAddRole + 1) * pageSizeAddRole >=
                        roleTableCount
                          ? "rgba(255,255,255,0.26)"
                          : "#c7c7c7",
                    }}
                  />
                </div>
              </>
            )}
            // onEditingRowSave={onEditHandle}
            renderRowActions={({ row, table }) => (
              <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
                {/* <Tooltip title="Edit">
                  <IconButton
                    sx={{ color: "#286685" }}
                    onClick={() => {
                      setEditColumn(false);
                      table.setEditingRow(row);
                    }}
                  >
                    <EditIcon />
                  </IconButton>
                </Tooltip> */}
                {(location.pathname === "/validForm" ||
                  cmpntGroup["user"]?.Add) && (
                  <Tooltip title="Delete Role">
                    <IconButton
                      // sx={{ color: "#c7c7c7" }}
                      onClick={() => {
                        openDeleteConfirmModal(row);
                        // data.splice(row.index, 1); //assuming simple data table
                        // setData([...allUserdata]);
                      }}
                    >
                      <DeleteIcon sx={{ color: "#c7c7c7" }} />
                    </IconButton>
                  </Tooltip>
                )}
                {(location.pathname === "/validForm" ||
                  cmpntGroup["user"]?.Update) && (
                  <Tooltip title={"User Role"}>
                    <IconButton
                      style={{ color: "#c7c7c7" }}
                      onClick={() => {
                        onPermission(true, row);
                      }}
                    >
                      <Settings style={{ color: "#c7c7c7 !important" }} />
                    </IconButton>
                  </Tooltip>
                )}
                {(location.pathname === "/validForm" ||
                  cmpntGroup["user"]?.Read) && (
                  <Tooltip title="Role Perm">
                    <IconButton
                      // sx={{ color: "#c7c7c7" }}
                      onClick={() => {
                        onPermissionRole(true, row);
                      }}
                    >
                      <ForwardIcon sx={{ color: "#c7c7c7" }} />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
            )}
          />
          <div>
            <Dialog open={deleteConfirmOpen} onClose={handleDeleteCancel}>
              <DialogTitle
                style={{ backgroundColor: "#161616", color: "#c7c7c7" }}
              >
                Delete Confirmation
              </DialogTitle>
              <DialogContent
                style={{ backgroundColor: "#333333 !important", color: "#c7c7c7 !important" }}
              >
                <p>Are you sure you want to delete the item?</p>
              </DialogContent>
              <DialogActions style={{ backgroundColor: "#161616",color: "#c7c7c7" }}>
                <Button
                  startIcon={<CloseIcon />}
                  onClick={handleDeleteCancel}
                  style={buttonStyle}
                  variant="contained"
                >
                  Cancel
                </Button>
                <Button
                  style={buttonStyle}
                  onClick={handleDeleteConfirm}
                  startIcon={<DeleteIcon />}
                >
                  Delete
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddRoles;
